import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#333",
      "stroke-width": ".5",
      d: "M13 15.98H7v.32a1 1 0 0 1-2 0v-.32H4a65.701 65.701 0 0 1 0-6.52c.108-2.166.294-3.726.558-4.68.075-.409.223-.72.447-.935.223-.214.549-.41.976-.585.428-.195 1.042-.37 1.842-.526.8-.156 1.53-.194 2.19-.194.661 0 1.392.038 2.192.194.8.156 1.414.331 1.842.526.427.176.753.37.976.585.223.215.382.526.475.936A37.95 37.95 0 0 1 16 9.459c.07 1.566.07 3.74 0 6.52h-1v.321a1 1 0 0 1-2 0v-.32zm-6.02-2.266a.9.9 0 0 1-.655.277.9.9 0 0 1-.656-.277.913.913 0 0 1-.279-.673c0-.263.093-.487.28-.673a.9.9 0 0 1 .655-.277.9.9 0 0 1 .656.277c.186.186.279.41.279.673a.913.913 0 0 1-.28.673zm7.43 0a.9.9 0 0 1-.655.277.9.9 0 0 1-.656-.277.914.914 0 0 1-.279-.673c0-.263.093-.487.28-.673a.9.9 0 0 1 .655-.277.9.9 0 0 1 .656.277c.186.186.279.41.279.673a.914.914 0 0 1-.28.673zM6.872 4.5h6.258c.494 0 .947.448 1.012 1l.352 3c.065.552-.341 1-.907 1H6.414c-.566 0-.972-.448-.907-1l.352-3c.065-.552.518-1 1.012-1z"
    }, null, -1)
  ]))]))
}
export default { render: render }